import { render, staticRenderFns } from "./TestQueryHistory.vue?vue&type=template&id=28e506a4&scoped=true&"
import script from "./TestQueryHistory.vue?vue&type=script&lang=js&"
export * from "./TestQueryHistory.vue?vue&type=script&lang=js&"
import style0 from "./TestQueryHistory.vue?vue&type=style&index=0&id=28e506a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e506a4",
  null
  
)

export default component.exports